import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { AUTO_SERVE_OPTIONS } from 'PointOfSale/modules/common/constants';

const QsiDropDownComponent = props => {
  const { sessions, activeSession, quickServeItems, onQSIClick } = props;
  const qsiItemId = _.get(sessions, [
    activeSession,
    'quickServeItem',
    'ItemId',
  ]);

  const autoServe = _.get(sessions, [activeSession, 'autoServe'], false);

  const mealCounter =
    _.get(sessions, [activeSession, 'queueType']) ===
    AUTO_SERVE_OPTIONS.MealCounter;

  const hideNone = autoServe || mealCounter;

  return (
    <React.Fragment>
      {!hideNone && (
        <Dropdown.Item
          key="None"
          className="borderNone borderBottomWithGray"
          value="None"
          selected={!qsiItemId}
          onClick={() => onQSIClick(null)}
        >
          <div className="sessionDropDownItem">None</div>
        </Dropdown.Item>
      )}
      {_.has(sessions, [activeSession]) &&
        _(quickServeItems)
          .uniqBy('ItemId')
          .sortBy('Description')
          .value()
          .map((item, index) => {
            const selected = item.ItemId === qsiItemId;
            return (
              <Dropdown.Item
                key={item.ItemId}
                className={classNames('borderNone', {
                  borderBottomWithGray: index !== quickServeItems.length - 1,
                })}
                selected={selected}
                value={item.ItemId}
                onClick={() => onQSIClick(item)}
              >
                <div className="sessionDropDownItem">{item.Description}</div>
              </Dropdown.Item>
            );
          })}
    </React.Fragment>
  );
};
QsiDropDownComponent.propTypes = {
  sessions: PropTypes.object,
  activeSession: PropTypes.string,
  quickServeItems: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onQSIClick: PropTypes.func,
};
export default QsiDropDownComponent;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/component/servingOptions/QsiDropDownComponent.js